<div #chartContainer class="google-linechart-container"></div>
